import { AppConfig } from "types/appConfig";

export const config: AppConfig = {
  name: 'ici',
  allowDefineIndivTripCost: true,
  allowSelectTripProtection: true,
  allowSpreadSheetImportTool: true,
  allowUseSponsorship: true,
  allowUsePrimaryInsuredPurchase: false,
  mtiApiUrl: "https://ici-triparmor-api.azurewebsites.net",
  selfUrl: "https://ici-triparmor-web.azurewebsites.net",
  gaId: "G-4X0YNFVQJ8",
  defaultAgentNumber: "16197TA1",
  apiUrl: "https://services.imglobal.com/API"
}